<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="row">
        <div class="col">
          <h6>Editar staff</h6>
        </div>
        <div class="col">
          <button class="btn btn-outline-dark btn-sm float-end" @click="$router.push('/staff')">Volver</button>
        </div>
      </div>
    </div>
    <div class="card-body px-4">
      <form @submit.prevent="update">
        <div class="row">
          <div class="col">
            <label>Nombre</label>
            <input type="text" class="form-control" v-model="form.name">
            <label>Correo electrónico</label>
            <input type="email" class="form-control" v-model="form.email">
            <label>Rol</label>
            <select class="form-control" v-model="form.type">
              <option value="agent">Agente</option>
              <option value="supervisor">Supervisor</option>
            </select>
            <label>Nueva contraseña (dejar vacío para no cambiarla)</label>
            <input type="text" class="form-control" v-model="form.password">
          </div>
          <div class="col">
            <label>Identificación</label>
            <input type="text" class="form-control" v-model="form.identification">
            <label>Teléfono</label>
            <input type="text" class="form-control" v-model="form.phone">
            <label>País</label>
            <input type="text" class="form-control" v-model="form.country">
            <label>IP autorizada</label>
            <div class="d-flex gap-2">
              <input type="text" class="form-control" v-model="form.allowed_ip" placeholder="Ej: 190.25.13.40">
              <button type="button" class="btn btn-outline-success mb-0" @click="assignIp">Guardar IP</button>
            </div>
          </div>
        </div>
        <button type="submit" class="btn bg-gradient-success mt-3 w-100">Actualizar información</button>
      </form>
    </div>
  </div>
</template>

<script>
import {get, post} from "@/utils/httpRequest";

export default {
  name: "staff-detail",
  data: () => ({
    form: {
      _id: '',
      name: '',
      email: '',
      type: 'agent',
      password: '',
      identification: '',
      phone: '',
      country: '',
      allowed_ip: '',
    }
  }),
  mounted() {
    this.getData()
  },
  methods: {
    async getData(){
      const id = this.$route.query.id
      const {data} = await get(`users/find-one?id=${id}`, null, true)
      if(data){
        this.form._id = data._id
        this.form.name = data.name || ''
        this.form.email = data.email || ''
        this.form.type = data.type || 'agent'
        this.form.identification = data.identification || ''
        this.form.phone = data.phone || ''
        this.form.country = data.country || ''
        this.form.allowed_ip = data.allowed_ip || ''
      }
    },
    async update(){
      const payload = {...this.form}
      if(!payload.password) delete payload.password
      const {data} = await post('users/update-staff', payload, true)
      if(data && data.statusCode === 200){
        this.$swal({
          html: 'Información actualizada con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
        this.form.password = ''
      }else{
        this.$swal({
          html: (data && data.message) || 'No se pudo actualizar',
          icon: 'error',
          timer: 2500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    },
    async assignIp(){
      const {data} = await post('users/assign-ip', {_id: this.form._id, allowed_ip: this.form.allowed_ip}, true)
      if(data && data.statusCode === 200){
        this.$swal({
          html: 'IP actualizada con éxito',
          icon: 'success',
          timer: 2000,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }else{
        this.$swal({
          html: (data && data.message) || 'No se pudo actualizar la IP',
          icon: 'error',
          timer: 2500,
          showCancelButton: false,
          showConfirmButton: false,
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.gap-2 {
  gap: 0.5rem;
}
</style>
